import React from 'react';
import { Reveal } from './Reveal';
const items = [{
  icon: '🎓',
  title: 'Módulo 1 — Quema de grasa',
  detail: 'Cómo funciona tu metabolismo y por qué caminar es la herramienta más poderosa',
  gift: false
}, {
  icon: '👟',
  title: 'Módulo 2 — Técnica y postura',
  detail: 'Caminá de forma eficiente, sin dolor y con máxima quema de calorías',
  gift: false
}, {
  icon: '❤️',
  title: 'Módulo 3 — Frecuencia cardíaca',
  detail: 'La zona exacta donde tu cuerpo quema grasa como combustible principal',
  gift: false
}, {
  icon: '📆',
  title: 'Módulo 4 — Planificación semanal',
  detail: 'Cómo organizar tus caminatas para progresar sin agotarte ni perder el ritmo',
  gift: false
}, {
  icon: '🥦',
  title: 'Módulo 5 — Nutrición inteligente',
  detail: 'Qué comer para potenciar cada caminata sin dietas imposibles',
  gift: false
}, {
  icon: '🧠',
  title: 'Módulo 6 — Mentalidad y constancia',
  detail: 'Cómo convertir la caminata en un hábito permanente que dure toda la vida',
  gift: false
}, {
  icon: '🎁',
  title: 'Bono 1 — Plan de Caminatas según tu Nivel',
  detail: 'Elegí tus caminatas según tu punto de partida y avanzá a tu ritmo',
  gift: true
}, {
  icon: '🎁',
  title: 'Bono 2 — Checklist de Hábitos',
  detail: 'Hábitos simples que potencian tu progreso cada día',
  gift: true
}, {
  icon: '🎁',
  title: 'Bono 3 — Errores Frecuentes',
  detail: 'Detectá qué puede frenarte y aprendé cómo corregirlo',
  gift: true
}];
export function WhatYouGet() {
  return <section className="w-full bg-cream" data-id="element-192" data-mp="3e4h1id9n3arw">
      <div className="mx-auto max-w-5xl px-5 py-16 sm:py-24" data-id="element-193" data-mp="397h2unf4daat">
        <Reveal className="text-center" data-id="element-194" data-mp="399bgrhrz425e">
          <h2 className="font-display text-3xl font-bold text-ink sm:text-4xl" data-id="element-195" data-mp="3o514bkct4nc8">
            Al inscribirte hoy obtenés
          </h2>
          <p className="mt-4 text-lg text-ink/70" data-id="element-196" data-mp="3j5xzo10qoj4s">
            Los 6 módulos completos + los 3 bonos de regalo, todo en un solo lugar.
          </p>
        </Reveal>

        <Reveal className="mt-12" data-id="element-197" data-mp="1orx01dxd7s3n">
          <div className="overflow-hidden rounded-2xl border border-ink/10 bg-white shadow-sm" data-id="element-198" data-mp="1osyfdulez0r6">
            {items.map((item, i) => <div key={item.title} className={`flex items-center gap-4 p-4 sm:p-5 ${i !== items.length - 1 ? 'border-b border-ink/10' : ''} ${item.gift ? 'bg-brand-light/40' : ''}`} data-id="element-199" data-mp="2ih4jv6oa2aq9" data-mpi={i}>
                <span className="text-2xl" data-id="element-200" data-mp="2sglnlijyyejl">{item.icon}</span>
                <div className="min-w-0 flex-1" data-id="element-201" data-mp="2xf6ozlayj49m">
                  <p className="text-sm font-bold text-ink sm:text-base" data-id="element-202" data-mp="2xcaopqbn03i0">{item.title}</p>
                  <p className="mt-0.5 text-xs leading-relaxed text-ink/60 sm:text-sm" data-id="element-203" data-mp="31e5rkz97uoxw">{item.detail}</p>
                </div>
                <span className={`flex-shrink-0 rounded-full px-3 py-1 text-xs font-bold ${item.gift ? 'bg-brand text-white' : 'bg-brand-light text-brand-dark'}`} data-id="element-204" data-mp="3b5s9tfjz1oa5">
                  {item.gift ? '🎁 Regalo' : '✅ Incluido'}
                </span>
              </div>)}
          </div>
        </Reveal>
      </div>
    </section>;
}